import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ListMixin from './listMixin';
import cloneDeep from 'lodash/cloneDeep';
import { userItemsPerListMixin } from '@/utils/vuex';
var defaultItemsPerPage = 10;
var defaultTableOptions = {
  sortBy: ['id'],
  sortDesc: [false],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
export default {
  name: 'ViewISAssetMgmtZones',
  mixins: [ListMixin, userItemsPerListMixin],
  data: function data() {
    return {
      tooltips: {},
      tooltip: false,
      listPersistencePath: 'IsAssetMgmt.zones',
      fetchType: 'zone',
      tableOptions: _objectSpread({}, defaultTableOptions)
    };
  },
  computed: {
    searchCategories: function searchCategories() {
      return [{
        value: 'title',
        text: this.$i18n_t('Common.help.titel')
      }, {
        value: 'id',
        text: "".concat(this.$i18n_t('DigitalTwin.DigitalTwin.types.zone'), " ").concat(this.$i18n_t('Common.id'))
      }, {
        value: 'floorDtwin.name',
        text: this.$i18n_t('DigitalTwin.DigitalTwin.types.floor')
      }, {
        value: 'floorDtwin.number',
        text: this.$i18n_t('DigitalTwin.DigitalTwin.map.floorLabel')
      }, {
        value: 'tag',
        text: this.$i18n_t('IS.AssetMgmt.list.category')
      }];
    },
    localizedTableOptions: function localizedTableOptions() {
      return {
        headers: [{
          text: this.$i18n_t('Common.id'),
          value: 'id',
          align: 'right',
          sortable: true
        }, {
          text: this.$i18n_t('Common.help.titel'),
          value: 'title',
          sortable: true
        }, {
          text: this.$i18n_t('IS.AssetMgmt.list.category'),
          value: 'category',
          sortable: false
        }, {
          text: this.$i18n_t('DigitalTwin.DigitalTwin.types.floor'),
          sortable: true,
          value: 'floorDtwin.title'
        }, {
          text: this.$i18n_t('DigitalTwin.DigitalTwin.types.building'),
          sortable: false,
          value: 'building.title'
        }, {
          text: this.$i18n_t('IS.AssetMgmt.list.assets'),
          sortable: false,
          value: 'trackables'
        }, {
          text: this.$i18n_t('Common.hierarchyLevel'),
          value: 'hierarchyLevel',
          sortable: true
        }, {
          text: this.$i18n_t('Common.tenant'),
          sortable: true,
          value: 'tenant.name'
        }, {}],
        footerProps: {
          itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
          itemsPerPageOptions: [10, defaultItemsPerPage, 20, 50]
        }
      };
    },
    headerBG: function headerBG() {
      return './img/consumer.png';
    }
  },
  watch: {
    list: function list() {
      var _this = this;

      this.tooltips = {};
      this.list.forEach(function (zone) {
        _this.tooltips[zone.id] = false;
      });
    }
  },
  created: function created() {
    this.tableOptions.page = defaultTableOptions.page;
    this.tableOptions.itemsPerPage = this.savedUserItemsPerList(); // this.fetchType = 'zone';
  },
  methods: {
    handleRowClick: function handleRowClick(item) {
      this.$router.push("/digitaltwin-mgmt/".concat(item.id));
    },
    toggleTrackablesTooltip: function toggleTrackablesTooltip(id) {
      if (this.tooltips[id] === true) {
        this.tooltips[id] = false;
      } else {
        this.tooltips[id] = true;
      }

      this.tooltips = cloneDeep(this.tooltips);
    },
    detailTableHeaderColClass: function detailTableHeaderColClass(header, props) {
      var classes = ["text-".concat(header.align || 'start')];

      if (header.sortable && ['title', 'id', 'floorDtwin.title'].indexOf(header.value) < 0) {
        classes.push('sortable');
      }

      var values = [header.value];

      if (props.options.sortBy && props.options.sortBy.length && values.indexOf(props.options.sortBy[0]) >= 0) {
        classes.push('active');

        if (props.options.sortDesc && props.options.sortDesc.length && props.options.sortDesc[0]) {
          classes.push('desc');
        } else {
          classes.push('asc');
        }
      }

      return classes.join(' ');
    },
    detailTableHeaderClasses: function detailTableHeaderClasses(props) {
      var sortBy = props.options.sortBy && props.options.sortBy.length ? props.options.sortBy[0] : 'none';
      var sortDesc = props.options.sortDesc && props.options.sortDesc.length && props.options.sortDesc[0];
      return {
        text: {
          title: "header-item-sortable ".concat(sortBy === 'title' ? 'header-active' : 'header-nonactive'),
          id: "header-item-sortable ".concat(sortBy === 'id' ? 'header-active' : 'header-nonactive'),
          floorDtwinTitle: "header-item-sortable ".concat(sortBy === 'floorDtwin.title' ? 'header-active' : 'header-nonactive')
        },
        icon: {
          title: sortBy === 'title' ? sortDesc ? 'icon-desc' : '' : 'icon-nonactive',
          id: sortBy === 'id' ? sortDesc ? 'icon-desc' : '' : 'icon-nonactive',
          floorDtwinTitle: sortBy === 'floorDtwin.title' ? sortDesc ? 'icon-desc' : '' : 'icon-nonactive'
        }
      };
    }
  }
};